<script lang="ts">
	import { Icon, IconButton } from '@Shelly/shelly-design-system';
	import { format } from 'svelte-i18n';
	import { createEventDispatcher } from 'svelte';

	export let showMenu = false;
	export let showFullscreen = false;
	export let dense = false;
	export let menuIcon = 'fa-regular fa-ellipsis-vertical';

	const dispatch = createEventDispatcher();
</script>

<div class="camera-overlay-actions" class:dense>
	{#if showFullscreen}
		<IconButton
			aria-label={$format('button_fullscreen', { default: 'Fullscreen' })}
			icon="fas fa-expand"
			variant="secondary"
			shape="circle"
			size="s"
			class={dense ? 'camera-overlay-action-btn' : ''}
			on:click={(e) => {
				e.stopPropagation();
				dispatch('fullscreen', e);
			}}
		/>
	{/if}
	{#if showMenu}
		<button
			type="button"
			class="camera-tile-embed-menu-button"
			class:dense
			aria-label={$format('button_open_device_drawer', {
				default: 'Open device menu',
			})}
			on:click={(e) => {
				e.stopPropagation();
				dispatch('menu-click', e);
			}}
		>
			<Icon icon={menuIcon} size="s" class="text-white" />
		</button>
	{/if}
</div>

<style>
	.camera-overlay-actions {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		gap: var(--spacing-xs);
		flex-shrink: 0;
		pointer-events: auto;
	}

	.camera-overlay-actions.dense {
		gap: 2px;
	}

	.camera-overlay-actions.dense :global(.camera-overlay-action-btn) {
		width: 24px;
		height: 24px;
		min-width: 24px;
		min-height: 24px;
	}

	.camera-overlay-actions.dense :global(.icon-grid) {
		font-size: 12px;
	}

	.camera-tile-embed-menu-button {
		display: flex;
		align-items: center;
		justify-content: center;
		margin: 0;
		padding: 6px 8px;
		border: none;
		background: none;
		cursor: pointer;
		flex-shrink: 0;
		pointer-events: auto;
	}

	.camera-tile-embed-menu-button.dense {
		padding: 4px;
	}

	.camera-tile-embed-menu-button:focus-visible :global(.icon-grid) {
		outline: 1px solid var(--color-primary);
		outline-offset: 4px;
		border-radius: 4px;
	}
</style>
